<template>
  <div class="row align-center testemunho_box2"
       v-if="listItems.length > 0">
    <div class="small-11 medium-11 large-11 columns content">
      <WebSlider
          @slideItemClicked="testemunhoClicked"
          :items="listItems" />
      <div class="btnwrapper">
        <TBotao
            class="btnvermais"
            @click="verTodosTestemunhos()"
            :border-color="this.color"
            :background-color="this.color"
            :text-color="this.color">
          {{ $translate("UMA_LANG_DEPARTAMENTOS_VERMAIS") }}
        </TBotao>
      </div>
    </div>
  </div>
</template>

<script>
import { WebSlider, TBotao } from "umaui";


export default {
  name: "testemunhosHome",
  components: {
    TBotao,
    WebSlider,
  },
  inject:["secundaryColors"],
  data() {
    return {
      listItems: [],
      color:""
    }
  },
  created() {
    const request = `${process.env.VUE_APP_AXIOS}/departamento/${this.$route.params.id}/testemunhos?idioma=${this.$store.state.language}&limit=3`;
    fetch(request)
        .then(response => response.json())
        .then(data => {
          this.listItems = data.map(el => {
            return {
              id: el.ID,
              Identificacao: el.Nome,
              Depoimento: el.Depoimento,
              Imagem: el.Imagem,
              Curso: el.Curso,
              url: el.Url,
              Faculdade: el.Faculdade
            };
          })
        })
        .catch(error => console.log(error));
  },
  updated() {
    this.color = this.secundaryColors[this.$store.state.color];
  },
  methods: {
    testemunhoClicked(e){
      console.log(e);
    },
    goToTestemunhoDetail(testemunho){
      window.location = testemunho.url
    },
    verTodosTestemunhos() {
      this.$router.push('testemunhos')
    },
  }
}
</script>

<style scoped>
.btnwrapper{
  display: flex;
  justify-content: center;
  padding-top: 27px;
}

.testemunho_box2 {
  background-color: #e9eaea;
}

.content {
  padding-right: 15px;
  padding-left: 10px;
}

/*.content .row .columns {
  padding-right: 6px;
  padding-left: 6px;
}*/

@media (max-width: 1440px) {
  .content {
    padding-right: 0;
    padding-left: 0;
  }
}
/*
@media (max-width: 776px) {
  .testemunho_box2 .content .row .columns {
    padding-right: 0;
    padding-left: 0;
  }
}*/


</style>